import { useMemo } from "react";
import { useSelector } from "react-redux";
import { HollowDotsSpinner } from "react-epic-spinners";
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Cell,
} from "recharts";

function WageTotals() {
  const { clockings } = useSelector((state) => state.clockings);
  const { departments } = useSelector((state) => state.departments);
  const { eligibleEmployeesClockIn } = useSelector(
    (state) => state.employeesList
  );
  const dataSet = useMemo(() => {
    let temp = 0;
    return [{ name: "Pagat", Total: temp.toFixed(2) }];
  }, [eligibleEmployeesClockIn, clockings, departments]);

  return (
    <>
      {!!clockings && !!eligibleEmployeesClockIn ? (
        <div className="clock-in-dashboard-card">
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ResponsiveContainer width="100%" height="95%">
              <BarChart
                data={dataSet}
                margin={{
                  top: 40,
                  right: 40,
                  left: 10,
                  bottom: 5,
                }}
              >
                <XAxis
                  dataKey="name"
                  scale="point"
                  padding={{ left: 50, right: 50 }}
                />
                <YAxis />
                <Tooltip />
                <Bar dataKey="Total" fill="#8884d8" barSize={80}>
                  {dataSet.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={"#1da193"} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <HollowDotsSpinner color="#1da193" size={24} />
        </div>
      )}
    </>
  );
}

export default WageTotals;
